import { lazy } from 'react';

// ✅ Lazy loading du composant Drawer (charge Ant Design Drawer ~80-100 KB)
export const Drawer = lazy(() =>
  import('./drawer.component').then((m) => ({
    default: m.Drawer,
  })),
);

// Export du contexte (ne peut pas être lazy loadé)
export { DrawerContext } from './drawer.component';

// Export des types
export type { DrawerType } from './drawer.component';
